import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Box, Text, VStack, Button} from '@salesforce/retail-react-app/app/components/shared/ui'
import {noop} from '@salesforce/retail-react-app/app/utils/utils'
import {useBrand} from '../../contexts/brand-context'

const CompleteRegistration = ({onBackToShoppingClick = noop}) => {
    const {isGarage} = useBrand()

    return (
        <VStack spacing="5" align="flex-start">
            <Text textStyle="webH2" as="h2">
                <FormattedMessage id="email_confirm.title" defaultMessage="One Last Step!" />
            </Text>
            <Text textStyle={'bodySmRegular'}>
                {isGarage ? (
                    <FormattedMessage
                        id="email_confirm.text.garage"
                        defaultMessage="To complete your registration, you’ll have to confirm your email address. You should receive an email in the next few minutes with the confirmation link. (If you can’t find it, check your spam folder.)"
                    />
                ) : (
                    <FormattedMessage
                        id="email_confirm.text.dynamite"
                        defaultMessage="To complete your registration, you’ll have to confirm your email address. You should receive an email in the next few minutes with the confirmation link. (If you can’t find it, check your spam folder.)"
                    />
                )}
            </Text>
            <Button
                variant={'webPrimary'}
                onClick={onBackToShoppingClick}
                alignSelf={{base: 'stretch', lg: 'flex-start'}}
            >
                <FormattedMessage id="email_confirm.back.btn" defaultMessage="Back to Shopping" />
            </Button>
        </VStack>
    )
}

CompleteRegistration.propTypes = {
    onBackToShoppingClick: PropTypes.func
}

export default CompleteRegistration
